import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-outlet',
	styleUrls: ['./outlet.component.css'],
	templateUrl: './outlet.component.html'
})
export class OutletComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
